import React, { useEffect, useState } from "react";
import { FormGroup, Input, Button, Form, Spinner, Row, Col } from "reactstrap";
import Dataservices from "../../services/requestApi";
import { Image, message } from "antd";
import Resizer from "react-image-file-resizer";

// Text editor
import TextEditor from "components/TextEditor";
import { useHistory } from "react-router-dom";

const AddProduct = ({ Allcategory }) => {
  const [subCategory, setSubCategory]= useState("");
  const [allSubCategory, setAllSubCategory]= useState([]);
  const [category, setCategoryId] = useState("");
  const [name, setName] = useState("");
  const [hsm, setHsm] = useState("");
  const [product_code, setProductCode] = useState("");
  const [gst, setGst] = useState("");
  const [slug, setSlug] = useState("");
  const [type, setType] = useState("");
  const [material, setMaterial] = useState("");
  const [mrp, setMrp] = useState("");
  const [price, setPrice] = useState("");
  const [brand, setBrand] = useState("");
  const [allBrand, setAllBrand] = useState([]);
  const [image, setImage] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [description, setDescription] = useState("");
  const [shortdescription, setShortDescription] = useState("");
  const [ready, setReady] = useState(false);
  const [COD, setCod] = useState(false);
  const [replacement, setReplacement] = useState(false);
  const [FOD, setFod] = useState(false);
  const [Quantity, setQuantity] = useState(0);
  let history = useHistory();

  useEffect(() => {
    getAllBrand();
  }, []);

  useEffect(() => {
    getAllSubCategory();
  }, []);
  // Get Filter By Category Id
  const getAllBrand = async (e) => {
    try {
      const resBrand = await Dataservices.BrandAll();
      setAllBrand(resBrand.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  // Get Filter By Category Id
  const getAllSubCategory = async (e) => {
    try {
      const resSubCategory = await Dataservices.SubCategoryAll();
      setAllSubCategory(resSubCategory.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const SubmitProduct = async (e) => {
    e.preventDefault();
    setReady(true);
    const data = new FormData();
    data.append("name", name);
    data.append("hsm", hsm);
    data.append("product_code", product_code);
    data.append("slug", slug);
    data.append("type", type);
    data.append("gst", gst);
    data.append("material", material);
    if (type === "single" || type === "multiple") {
      data.append("mrp", mrp);
      data.append("price", price);
    }
    data.append("COD", COD);
    data.append("FOD", FOD);
    data.append("quantity", Quantity);
    data.append("Replacement", replacement);
    data.append("category", category);
    data.append("sub_category", subCategory);
    data.append("brand_id", brand);
    image.forEach((element) => {
      data.append("image", element);
    });
    data.append("description", description);
    data.append("short_description", shortdescription);

    try {
      const res = await Dataservices.ProductAdd(data);
      console.log(res.data);
      if (res?.data?.status_code === 500) {
        message.error("Something Went Wrong");
        setReady(false);
      } else {
        setReady(false);
        history.goBack();
      }
    } catch (e) {
      console.log(e.response.data);
      if (e.response.data) {
        message.success(e.response.data.message);
        setReady(false);
      }
    }
  };

  const fileHandler = (e) => {
    // console.log(...e.target.files)
    const file = [...e.target.files];
    if (file) {
      setImage([]);
      setThumbnail([]);
      file.forEach((file) => {
        Resizer.imageFileResizer(
          file,
          500,
          500,
          "JPEG",
          90,
          0,
          (uri) => {
            setImage((prev) => [...prev, uri]);
            setThumbnail((prev) => [...prev, uri]);
          },
          "file",
          500,
          500
        );
      });
    } else {
      setImage(null);
      setThumbnail(null);
    }
  };
  const HandleName = (e) => {
    let text = e.target.value;
    const slugtext = text.toLocaleLowerCase().replaceAll(" ", "-");
    setName(text);
    setSlug(slugtext);
  };

  return (
    <>
      <Form role="form" onSubmit={SubmitProduct} encType="multipart/form-data">
        <Row>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Brand
              </label>
              <Input
                type="select"
                id="paid"
                value={brand}
                className="form-control-alternative"
                onChange={(e) => setBrand(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                {allBrand?.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}{" "}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Product Type
              </label>
              <Input
                type="select"
                id="paid"
                value={type}
                className="form-control-alternative"
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value="single">Single </option>
                <option value="multiple">Multiple</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Category
              </label>
              <Input
                type="select"
                id="paid"
                value={category}
                className="form-control-alternative"
                onChange={(e) => setCategoryId(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                {Allcategory &&
                  Allcategory.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.category}{" "}
                    </option>
                  ))}
              </Input>
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label" htmlFor="name">
                Name
              </label>
              <Input
                className="form-control-alternative"
                id="name"
                placeholder="Name"
                type="text"
                value={name}
                onChange={HandleName}
                required
              />
            </FormGroup>
          </Col>
          {(type === "single" || type === "multiple") && (
            <>
              <Col lg="4">
                <FormGroup>
                  <label className="form-control-label" htmlFor="Brand">
                    Mrp
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="Brand"
                    placeholder="Enter Mrp"
                    type="text"
                    value={mrp}
                    onChange={(e) => setMrp(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <label className="form-control-label" htmlFor="Brand">
                    Price
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="Brand"
                    placeholder="Enter Price"
                    type="text"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="hsn">
                HSN
              </label>
              <Input
                type="text"
                id="hsn"
                placeholder="Enter HSN"
                className="form-control-alternative"
                onChange={(e) => setHsm(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label
                className="form-control-label d-block"
                htmlFor="product_code"
              >
                Product Code
              </label>
              <Input
                type="text"
                id="product_code"
                placeholder="Enter Product code"
                className="form-control-alternative"
                onChange={(e) => setProductCode(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="gst">
                GST (%)
              </label>
              <Input
                type="number"
                id="gst"
                value={gst}
                placeholder="Enter GST "
                className="form-control-alternative"
                onChange={(e) => setGst(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Cash on Delivery
              </label>
              <Input
                type="select"
                id="paid"
                className="form-control-alternative"
                onChange={(e) => setCod(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                7 Days replacement
              </label>
              <Input
                type="select"
                id="paid"
                className="form-control-alternative"
                onChange={(e) => setReplacement(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Sub Category
              </label>
              <Input
                type="select"
                id="paid"
                value={subCategory}
                className="form-control-alternative"
                onChange={(e) => setSubCategory(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                {allSubCategory &&
                  allSubCategory.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.sub_category}{" "}
                    </option>
                  ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Free Delivery
              </label>
              <Input
                type="select"
                id="paid"
                className="form-control-alternative"
                onChange={(e) => setFod(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Quantity
              </label>
              <Input
                type="number"
                value={Quantity}
                className="form-control-alternative"
                onChange={(e) => setQuantity(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <label className="form-control-label" htmlFor="image">
            Image
          </label>
          <Input
            className="form-control-alternative"
            id="image"
            type="file"
            accept="image/*"
            onChange={fileHandler}
            multiple
          />
          {thumbnail &&
            thumbnail.map((item) => (
              <Image
                width={200}
                src={URL.createObjectURL(item)}
                className="mt-3"
              />
            ))}
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="Brand">
            Material
          </label>
          <Input
            className="form-control-alternative"
            id="Brand"
            placeholder="Enter Material"
            type="text"
            value={material}
            onChange={(e) => setMaterial(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="short_des">
            Short Description
          </label>
          <Input
            className="form-control-alternative"
            id="short_des"
            placeholder="Enter Short Description"
            type="textarea"
            rows="4"
            value={shortdescription}
            onChange={(e) => setShortDescription(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="desc">
            Description
          </label>
          <TextEditor value={description} setvalue={setDescription} />
        </FormGroup>
        <Button
          className="my-4 btn-block"
          type="submit"
          color="warning"
          disabled={ready}
        >
          {ready && <Spinner size="sm" color="light" />} Add Product
        </Button>
      </Form>
    </>
  );
};
export default AddProduct;
